import React, { useEffect } from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';

import { PageHeader, UtilitiesPanel, Spinner, IframeView } from '../../components';
import { retrieveDailyUsageHistory } from '../../services/userService';
import { META_TITLE, Use_Alt_Consumption_History } from '../../utils/constants';
import { buildIframeUrl } from '../../utils/iframe';
import * as S from './Services.styles';

export default function Home() {
	const [status, setStatus] = useState('loading');
	const currentLocation = useSelector((state) => state.location.value);
	const [meterData, setMeterData] = useState([]);

	// Portal_User_Login flag deciding between the standard page and the embedded iframe version
	const useAltConsumptionHistoryPage = window.localStorage.getItem(Use_Alt_Consumption_History) === 'true';

	async function init() {
		if (currentLocation?.UtilityAccount?.AccountKey) {
			try {
				const meters = await retrieveDailyUsageHistory({ accountKey: currentLocation?.UtilityAccount?.AccountKey, usageDays: 15 });
				setMeterData(meters);
				setStatus('success');
			} catch (e) {
				toast.error(e.message);
				setStatus('error');
			}
		} else {
			setStatus('error');
		}
	}

	useEffect(() => {
		// Set document title
		document.title = `Consumption History | ${META_TITLE}`;

		// Skip usage data when rendering the embedded iframe version
		if (useAltConsumptionHistoryPage) return;

		// Retrieve usage data
		if (currentLocation?.UtilityAccount != null) {
			init();
		} else {
			setStatus('success');
		}
	}, []);

	if (useAltConsumptionHistoryPage) {
		return (
			<S.IframeWrapper>
				<PageHeader>Consumption History</PageHeader>
				<IframeView src={buildIframeUrl('cpConsumptionHistory', { locationID: currentLocation?.LocationID })} title="Consumption History" />
			</S.IframeWrapper>
		);
	}

	return (
		<S.Wrapper>
			<PageHeader>Consumption History</PageHeader>
			{status === 'loading' ? <Spinner /> : <>{currentLocation?.UtilityAccount != null && <UtilitiesPanel className="a1" meters={meterData} />}</>}
		</S.Wrapper>
	);
}
